export default [
    // 为方便 放到这个里边  审核-添加节点
    {
        path: '/static/audit/flow/node',
        name: 'audit-node',
        component: () => import('views/modules/audit/node/index.vue'),
        meta: {
            parent: '/audit/flow',
            icon: 'el-icon-document',
            title: '审核流程',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
    {
        path: '/static/setting/domain/check',
        name: 'domain-check',
        component: () => import('components/ce-index-widget/widget-website-info/domain-check.vue'),
        meta: {
            parent: '/setting/domain',
            icon: 'el-icon-document',
            title: '检测页面',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
    // {
    //     path: '/audit/node/:appId',
    //     name: 'product-edit',
    //     component: () => import('views/modules/product/edit'),
    //     meta: {
    //         parent: '/product/list',
    //         icon: 'el-icon-document',
    //         title: '添加产品',
    //         path: '',
    //         isApp: false,
    //         isIframe: false,
    //         isLink: false,
    //         isAffix: false,
    //         isHide: false,
    //         params: {},
    //     },
    // },
];
